import React from 'react';
import { useTranslation } from './localization';

export default function SecurityBadge() {
  const tr = useTranslation();
  return <a className="security-verification" href="https://fortifynet.com/Onboarding?domain=earlybird.live" target="_blank" rel="noopener noreferrer">
    <svg width="25" height="28" viewBox="0 0 24 28" fill="none" aria-hidden="true"><path d="M12 2 3 6v7c0 6 9 11 9 11s9-5 9-11V6L12 2Z" stroke="currentColor" strokeWidth="1.6"/><path d="m8 13 3 3 5-6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/></svg>
    <span><span className="security-verification-title">{tr('Security verification by FortifyNet')}</span><small>{tr('Run your own website security check')} <span aria-hidden="true">↗</span></small></span>
  </a>;
}
